import React from 'react';
import { useTranslation } from 'react-i18next';
import { Paper, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, TablePagination } from '@mui/material';

const DataTable = ({columns, rows, totalRows, pageSize, page, handlePageChane, handlePageSizeChange}) => {
    const { t } = useTranslation();

    return (
        <>
            <TableContainer
                component={Paper}
                sx={{
                    backgroundColor: (theme) => theme.custom.card,
                    boxShadow: (theme) => theme.custom.cardShadow,
                    border: (theme) => `1px solid ${theme.custom.border}`,
                }}
            >
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                        {columns.map((c,i) => 
                            <TableCell key={i} style={c.style}>{c.name}</TableCell>
                        )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {rows.map((r, i) =>
                        <TableRow key={i}>
                        {columns.map((c, k) =>
                            <TableCell key={k}>{r[c.field]}</TableCell>
                        )}
                        </TableRow>
                    )}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10,20,50,100]}
                component="div"
                count={totalRows}
                rowsPerPage={pageSize}
                page={page}
                onPageChange={handlePageChane}
                onRowsPerPageChange={handlePageSizeChange}
                labelRowsPerPage={t('common.pagination.rowsPerPage')}
                labelDisplayedRows={({ from, to, count }) => (
                    count !== -1
                        ? t('common.pagination.displayedRowsOf', { from, to, count })
                        : t('common.pagination.displayedRowsMoreThan', { from, to })
                )}
            />
        </>
    )
}

export default DataTable;